import { useVirtualizer } from "@tanstack/react-virtual";
import { useRef } from "react";
import { useTranslation } from "react-i18next";
import useAccessLogScrollElement from "../hooks/useAccessLogScrollElement";
import type { AccessLogListItem } from "../types/accessLog";

// 첫 배치용 어림값 (실측 웹 73/89, 웹뷰 57/73). 실제 높이는 measureElement 가 보정
const ACCESS_LOG_ROW_ESTIMATED_HEIGHT = 73;

type AccessLogListProps = {
  accessLogs: AccessLogListItem[];
};

function AccessLogList({ accessLogs }: AccessLogListProps) {
  const { t } = useTranslation("access");
  const listRef = useRef<HTMLUListElement>(null);
  const hasAccessLogs = accessLogs.length > 0;
  const scroll = useAccessLogScrollElement(listRef, hasAccessLogs);

  const virtualizer = useVirtualizer({
    count: accessLogs.length,
    getScrollElement: () => scroll.element,
    estimateSize: () => ACCESS_LOG_ROW_ESTIMATED_HEIGHT,
    overscan: 10,
    scrollMargin: scroll.margin,
    getItemKey: (index) => accessLogs[index]?.id ?? index,
  });

  if (!hasAccessLogs)
    return (
      <div className="empty-container">
        <div className="empty-text">{t("noAccessLogs")}</div>
      </div>
    );

  return (
    <div className="list-container">
      <ul ref={listRef} className="list-container__inner" style={{ height: `${virtualizer.getTotalSize()}px` }}>
        {virtualizer.getVirtualItems().map((virtualItem) => {
          const accessLog = accessLogs[virtualItem.index];
          return (
            <li
              key={accessLog.id}
              className="list-container__row"
              data-index={virtualItem.index}
              ref={virtualizer.measureElement}
              style={{ transform: `translateY(${virtualItem.start - virtualizer.options.scrollMargin}px)` }}
            >
              <div className="date">{accessLog.accessDate}</div>
              <div className="phoneNumber">{accessLog.phoneNumber}</div>
              <div className="title">{accessLog.deviceName}</div>
              <div className="isAccess">{accessLog.eventName}</div>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
export default AccessLogList;
